var $a0c6dc87c8a2167a$exports = {};
$a0c6dc87c8a2167a$exports = {
    "loading": `L\xe4ser in...`,
    "placeholder": `V\xe4lj\u{2026}`
};


export {$a0c6dc87c8a2167a$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
